export default "__VITE_ASSET__Bb5Z83yG__"